/** Joins class names, dropping anything falsy. Small on purpose: the
 *  console has no conditional-variant explosion worth a dependency. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
